/* =====================================================================
   CIMASUR · Motor de interactividad (vanilla JS, sin librerías)
   Cada init comprueba si su elemento existe: seguro en cualquier página.
   ===================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll (IntersectionObserver único) ---------- */
  function initReveals() {
    var els = document.querySelectorAll('.cs-reveal, [data-cs-stagger]');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cs-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cs-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Cifras que cuentan hacia arriba ---------- */
  function initCountUp() {
    var nums = document.querySelectorAll('[data-cs-count]');
    if (!nums.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = formatNum(n); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animateCount(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }
  function decimalsOf(raw) {
    var i = raw.indexOf('.');
    return i === -1 ? 0 : (raw.length - i - 1);
  }
  function fmt(val, dec) {
    return val.toLocaleString('es-CL', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  }
  function formatNum(el) {
    var raw = (el.getAttribute('data-cs-count') || '0').replace(',', '.');
    var target = parseFloat(raw) || 0;
    return (el.getAttribute('data-cs-prefix') || '') + fmt(target, decimalsOf(raw)) + (el.getAttribute('data-cs-suffix') || '');
  }
  function animateCount(el) {
    var raw = (el.getAttribute('data-cs-count') || '0').replace(',', '.');
    var target = parseFloat(raw) || 0;
    var dec = decimalsOf(raw);
    var prefix = el.getAttribute('data-cs-prefix') || '';
    var suffix = el.getAttribute('data-cs-suffix') || '';
    var dur = 1400, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = target * eased;
      el.textContent = prefix + fmt(val, dec) + suffix;
      if (p < 1) requestAnimationFrame(step); else el.textContent = prefix + fmt(target, dec) + suffix;
    }
    requestAnimationFrame(step);
  }

  /* ---------- Añadir al carrito con 1 clic (tarjetas de producto) ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cs-quickadd]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-cs-quickadd');
      if (!id || btn.disabled) return;
      var original = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '…';
      addToCart(id, 1, btn).then(function () {
        btn.innerHTML = '✓';
        setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1200);
      }).catch(function () {
        btn.innerHTML = original; btn.disabled = false;
      });
    });
  }

  function addToCart(variantId, qty, sourceBtn) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(variantId), quantity: qty || 1 }] };
    if (drawer) {
      body.sections = sectionsToRender(drawer);
      body.sections_url = window.location.pathname;
    }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || 'error');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
        if (typeof drawer.open === 'function') drawer.open(sourceBtn || undefined);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      return res;
    });
  }
  window.csAddToCart = addToCart;

  function sectionsToRender(drawer) {
    if (drawer && drawer.getSectionsToRender) {
      try { return drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  /* ---------- Botón "Comprar" fijo en móvil (página de producto) ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('.cs-sticky-atc');
    if (!bar) return;
    var anchor = document.querySelector('[data-cs-atc-anchor]');
    if (!anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Muestra la barra cuando el botón principal ya NO está visible
        if (entry.boundingClientRect.top < 0 && !entry.isIntersecting) {
          bar.classList.add('is-on');
        } else if (entry.isIntersecting) {
          bar.classList.remove('is-on');
        }
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- Página de producto: galería + variantes ---------- */
  window.csInitProduct = function () {
    var root = document.querySelector('[data-cs-product]');
    if (!root) return;

    // Galería: cambiar imagen principal al pulsar miniatura
    var main = root.querySelector('[data-cs-gallery-main] img');
    var thumbs = root.querySelectorAll('[data-cs-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (main && full) { main.src = full; }
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    // Variantes
    var dataEl = root.querySelector('[data-cs-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = root.querySelectorAll('[data-cs-option]');
    if (!selects.length) return;

    var idInput = root.querySelector('[data-cs-variant-id]');
    var priceEl = root.querySelector('[data-cs-price]');
    var compareEl = root.querySelector('[data-cs-compare]');
    var addBtn = root.querySelector('[data-cs-add]');
    var stickyPrice = document.querySelector('.cs-sticky-atc__price');
    var moneyFmt = root.getAttribute('data-cs-money') || '${{amount}}';

    function currentOptions() {
      return Array.prototype.map.call(selects, function (s) { return s.value; });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function fmtMoney(cents) {
      var amount = (cents / 100);
      // CLP sin decimales
      var s = Math.round(amount).toLocaleString('es-CL');
      return moneyFmt.replace('{{amount}}', s).replace('{{amount_no_decimals}}', s);
    }
    function update() {
      var v = findVariant(currentOptions());
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'No disponible'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = fmtMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.innerHTML = fmtMoney(v.compare_at_price);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (stickyPrice) stickyPrice.innerHTML = fmtMoney(v.price);
      if (addBtn) {
        if (v.available) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute('data-label') || 'Agregar al carrito'; }
        else { addBtn.disabled = true; addBtn.textContent = 'Agotado'; }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();

    // Botón fijo móvil: al pulsar, dispara el add del formulario principal
    var stickyBtn = document.querySelector('[data-cs-sticky-add]');
    if (stickyBtn && addBtn) {
      stickyBtn.addEventListener('click', function () { addBtn.click(); });
    }

    // Envío del formulario -> añadir al carrito y abrir cajón
    var form = root.querySelector('[data-cs-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = findVariant(currentOptions());
        if (!v || !v.available) return;
        var qtyInput = form.querySelector('[name="quantity"]');
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        var label = addBtn.getAttribute('data-label') || 'Agregar al carrito';
        addBtn.disabled = true; addBtn.textContent = 'Agregando…';
        addToCart(v.id, qty, addBtn).then(function () {
          addBtn.textContent = '✓ Agregado';
          setTimeout(function () { addBtn.disabled = false; addBtn.textContent = label; }, 1400);
        }).catch(function () { addBtn.disabled = false; addBtn.textContent = label; });
      });
    }
  };

  /* ---------- Init ---------- */
  function boot() {
    initReveals();
    initCountUp();
    initQuickAdd();
    initStickyAtc();
    if (window.csInitProduct) window.csInitProduct();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Reinit reveals cuando el editor de Shopify carga secciones
  document.addEventListener('shopify:section:load', function () {
    initReveals(); initCountUp(); initStickyAtc();
  });
})();
